import React from "react";
import { Link } from "../../utils/link";
import SvgArrow from "../../assets/icons/SvgArrow";
import footerBg from "../../assets/images/FooterBg.svg";
import UseFooter from "../../staticQueries/useFooter";
import FooterFeatures from "./Features";
import NeedHelp from "./NeedHelp";
import FooterAboutUs from "./AboutUs";
import NeedHelpMobile from "./NeedHelpMobile";
import Subscribe from "./Subscribe";
import SocialLinks from "./SocialLinks";

export default function Footer() {
  const footer = UseFooter();

  return (
    // Main Footer
    <footer
      className={`relative bg-[#1f1f1f] text-white after:absolute after:contents-[''] after:top-0 after:left-0 after:w-full after:h-[93%] 
      after:bg-no-repeat after:bg-cover after:z-0 after:[background-position-y: 50px] z-0`}
      style={{
        backgroundImage: `url(${footerBg})`,
        backgroundPositionY: "50px",
        backgroundSize: "100% 100%",
      }}
    >
      {/* Need Help and About Section */}
      <div className="relative px-1 sm:px-5 xl:px-[90px] pt-10 md:pt-[90px] z-[1]">
        <div className="hidden md:flex">
          <NeedHelp needHelp={footer.needHelp} />
          <FooterAboutUs aboutUs={footer.aboutUs} />
        </div>
        {/*Mobile sections */}
        <NeedHelpMobile aboutUs={footer.aboutUs} needHelp={footer.needHelp} />
        <div className="block md:hidden self-center w-full mt-10 border-[0.5px] border-solid border-white/60" />
      </div>
      {/* Subrcibe Section */}
      <Subscribe subscribeHeadline={footer.subscribeHeadline} />
      {/* copy write section Desktop */}
      <div className="relative hidden md:flex justify-between items-center order-2 md:order-1 px-0 md:px-5 xl:px-[90px] z-[1] py-[30px]">
        <div className="text-white opacity-60 ml-0 w-[10%] md:w-[32%] h-[2px] bg-white/60" />
        <p
          className="text-xs tracking-wide md:tracking-wider leading-[17px] md:leading-[25px] cursor-pointer text-white
          opacity-60 text-center"
        >
          All copyright reserved to Bushbuck © 2025
        </p>
        <div className="text-white opacity-60 mr-0 w-[10%] md:w-[32%] h-[2px] bg-white/60" />
      </div>
      <SocialLinks
        paymentOptions={footer.paymentOptions}
        socialLinks={footer.socialLinks}
      />
      {/* copy write section Mobile */}
      <div className="relative flex md:hidden justify-between items-center order-2 md:order-1 px-0 md:px-5 xl:px-[90px] z-[1] pb-5">
        <div className="text-white opacity-60 ml-0 w-[10%] md:w-[32%] h-[2px] bg-white/60" />
        <p
          className="text-[10px] tracking-wide md:tracking-wider leading-[17px] md:leading-[25px] cursor-pointer text-white
          opacity-60 text-center"
        >
          All copyright reserved to Bushbuck © 2025
        </p>
        <div className="text-white opacity-60 mr-0 w-[10%] md:w-[32%] h-[2px] bg-white/60" />
      </div>
    </footer>
  );
}
